export const RETRY_FETCH = 'campaignsStatistics/RETRY_FETCH';
